import { render } from "./About.vue?vue&type=template&id=7cb3d28c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=7cb3d28c&scoped=true&lang=css"

import exportComponent from "/Users/shussain/Development/Web/uk.co.abdulsbaltihouse/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb3d28c"]])

export default __exports__